import { render, staticRenderFns } from "./Propose.vue?vue&type=template&id=02eccbba&scoped=true"
import script from "./Propose.vue?vue&type=script&lang=js"
export * from "./Propose.vue?vue&type=script&lang=js"
import style0 from "./Propose.vue?vue&type=style&index=0&id=02eccbba&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02eccbba",
  null
  
)

export default component.exports